
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referrals",
      function () {
        return require("private-next-pages/referrals/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referrals"])
      });
    }
  